
export class FileUploader {
    static $inject = ['Upload'];

    constructor(Upload) {
        this.Upload = Upload;
    }

    getUploader(){
       return this.Upload;
    }
}



// WEBPACK FOOTER //
// ./src/utils/file-uploader.js